import {React} from 'react';

export default function Loading({messsage="Chargement en cours..."}) {
    return (
        <div className="text-center mt-5">
            <i className="fas fa-circle-notch fa-spin fa-3x text-primary mb-3"></i><br />
            <b>{messsage}</b>
        </div>
    )
}